export default __webpack_public_path__ + "static/fcc-horizontal-728x90-4c80e6d6b9fab64f434e3b648e0b7721.png";